import styled from "@emotion/styled";
import React from "react";
import { useGetAppointmentsQuery } from "src/api/appointmentsApiSlice";
import { Rejected } from "./Rejected";
import { Requests } from "./Requests";
import { Upcoming } from "./Upcoming";

const AppointmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;
const Appointments = (props) => {
  return (
    <AppointmentContainer>
      <Upcoming />
      <Requests />
      <Rejected />
    </AppointmentContainer>
  );
};

export { Appointments };
